<template>
  <div class="is-loading" v-if="isLoading">
    <b-spinner style="border-width: 2px" />
  </div>
  <div v-else>
    <template v-if="dateType == 'limited'">
      <div class="dynamic-select">
        <b-form-select
          v-model="datetime"
          @input="handleInput"
          :disabled="disabled"
        >
          <b-form-select-option :value="null">{{ placeholder }}</b-form-select-option>
          <b-form-select-option
            v-for="(timeOption, optIdx) in dateOptions"
            :key="'date-opt-' + optIdx + '-' + (timeOption.value || '')"
            :value="timeOption.value"
            :disabled="optionDisabler(timeOption.value)"
          >
            {{ dateOptionDisplayLabel(timeOption) }}
          </b-form-select-option>
        </b-form-select>
      </div>
    </template>
    <AppDatePicker
      v-else
      v-model="datetime"
      :hasError="hasError"
      :placeholder="placeholder"
      @input="handleInput"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import AppDatePicker from '@/components/AppDatePicker.vue';
import moment from "moment";

export default {
  props: {
    value: [Date, String],
    placeholder: {
      type: String,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    dateOptions: {
      type: Array,
      default: () => [],
    },
    dateType: {
      type: String,
      default: "unlimited",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    optionDisabler: {
      type: Function,
      default: (timeOption) => false, // eslint-disable-line
    },
  },
  components: {
    AppDatePicker,
  },
  data: () => ({
    datetime: null,
  }),
  watch: {
    value() {
      this.datetime = this.value
    },
    dateOptions() {
      this.triggerOptionsChangeDetection()
    },
  },
  mounted() {
    this.datetime = this.value
  },
  methods: {
    dateOptionDisplayLabel(option) {
      const alias = option.text != null ? String(option.text).trim() : ''
      if (alias !== '') {
        return alias
      }
      if (!option.value) {
        return ''
      }
      return moment(option.value).format('YYYY/MM/DD')
    },
    triggerOptionsChangeDetection() {
      if (false === this.dateOptions.some((option) => option.value === this.datetime)) {
        this.datetime = null
        this.handleInput()
      }
    },
    handleInput() {
      if (!this.datetime) {
        this.$emit('input', null)
        this.$emit('change', null)
        return
      }

      this.$emit("input", moment(this.datetime).format("YYYY-MM-DD"));
      this.$emit('change', null)
    },
  },
};
</script>

<style lang="scss" scoped>
.dynamic-select {
  position: relative;
  font-family: "PingFang TC";
  font-style: normal;
  font-weight: 600;
  width: 100%;

  select {
    padding: 0px 1rem;
    -moz-appearance: none; /* Firefox */
    -webkit-appearance: none; /* Safari and Chrome */
    appearance: none;
    font-size: 16px;
    border: dotted 1px var(--liff-button-color) !important;
    border-radius: 3px;

    .dynamic-select--border & {
      border: 1px solid #636366;
      border-radius: 10px;
      padding: 16px 12px;
      &:focus {
        border-bottom-color: #636366;
      }
    }
  }

  &__caret {
    position: absolute;
    right: 20px;
    width: 12px;
    bottom: 30%;
  }

  &--border {
    select {
      border: 1px solid #636366;
      border-radius: 10px;
      padding: 16px 12px;
      &:focus {
        border-bottom-color: #636366;
      }
    }
  }

  &.invalid {
    border: 1px solid #fe0000;
  }
}

.is-loading {
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: unset;
}
</style>
